import { render, staticRenderFns } from "./QuestionBankTagList.vue?vue&type=template&id=5c039c8d&"
import script from "./QuestionBankTagList.vue?vue&type=script&lang=js&"
export * from "./QuestionBankTagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports